import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input, ViewChild, AfterViewInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatSort, MatPaginator, MatTableDataSource, MatMenuTrigger, SortDirection } from '@angular/material';
import { SharedAnimations } from 'src/app/shared/animations/shared-animations';
import { Pipe, PipeTransform } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  animations: [SharedAnimations],
})

export class TableComponent implements OnInit, AfterViewInit, OnChanges {

  @Input('displayedColumns') displayedColumns;
  @Input('serverData') serverData;
  @Input('columnsToDisplay') columnsToDisplay;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() childEvent = new EventEmitter();
  @Output() actionEvent = new EventEmitter();
  @Output() tableSortDetails = new EventEmitter();
  @Input('totalPaginationCount') totalPaginationCount;
  @Output() tablePaginationDetails = new EventEmitter();
  @Output() forActiveStatus = new EventEmitter();
  @Output() forPremiumStatus = new EventEmitter();
  @Output() editData = new EventEmitter();
  @Output() viewItem = new EventEmitter();
  @Output() reviewItem = new EventEmitter();
  @Output() delete_multiple = new EventEmitter();
  @Output() deleteData = new EventEmitter();

  dataSource: any;
  checkboxx: any;
  color = 'primary';
  multi_select_ids: any = [];

  constructor() {
  }

  ngOnChanges() {
    if (this.serverData) {
      this.dataSource = new MatTableDataSource(this.serverData);
    }
    // this.dataSource.sort = this.sort;
    // this.dataSource.paginator = this.paginator;
  }

  status(event, status) {
    event.status = status;
    this.forActiveStatus.emit(event);
  }

  premiumMemberStatus(event, status) {
    event.premiumMember = status;
    this.forPremiumStatus.emit(event);
  }

  editItem(event) {
    this.editData.emit(event);
  }

  viewElement(event) {
    this.viewItem.emit(event);
  }

  reviewElement(event) {
    this.reviewItem.emit(event);
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
  }

  onlyOne(event, elem) {
    if (elem) {
      this.checkboxx = elem.id;
    }
    if (event.target.checked === true) {
      // this.selected = true;
      this.childEvent.emit({ selected: true, id: elem.id });

    } else {
      //  this.selected = false;
      this.childEvent.emit({ selected: false, id: elem.id });
      this.checkboxx = null;
    }
  }

  selectMultipleCheckbox(event, elem) {
    if (event.target.checked) {
      this.multi_select_ids.push(elem.id)
    } else {
      let index = this.multi_select_ids.indexOf(elem.id)
      if (index > -1) {
        this.multi_select_ids.splice(index, 1)
      }
    }
    this.delete_multiple.emit(this.multi_select_ids);
  }

  action(elem) {
    // this.actionEvent.emit({id: elem.id});
  }

  tableHead(event) {
    this.tableSortDetails.emit(event);
  }
  pageChange(event) {
    this.tablePaginationDetails.emit(event);
  }
  deleteItem(event) {
    this.deleteData.emit(event);
  }
}

@Pipe({ name: 'titleCase' })
export class TitleCasePipe implements PipeTransform {
  public transform(input: string): string {
    if (!input) {
      return '';
    } else {
      return input.replace(/\b\w/g, first => first.toLocaleUpperCase())
    }
  }
}
